import { TimerUserModel } from "./TimerUserModel";

/**
 * * Модель записи таймера
 */
export class TimerRecordModel {
  /**ID таймера */
  TimerId!: number;
  /**Дата старта таймера */
  DateStart!: Date;
  /**Дата окончания таймера */
  DateEnd?: Date;
  /**ID задачи */
  TaskId!: number;
  /**Исполнитель */
  Performer?: TimerUserModel;

  constructor(obj?: Partial<TimerRecordModel>) {
    Object.assign(this, obj);
  }
}
